import { useSelector } from 'react-redux';
import isNil from 'lodash/isNil';
import { setVolume } from '../actions/player';
import { selectPlayerVolume } from '../selectors/player';
import { getVolume as getVolumeFromStorage } from '../utils/storage/playerVolume';
import useOnMount from './useOnMount';
import useActions from './useActions';

export function useSetPlayerVolume() {
  const actions = useActions({
    setVolume,
  });
  const volume = useSelector(selectPlayerVolume);

  useOnMount(() => {
    const volumeFromStorage = getVolumeFromStorage();
    const volumeToSet =
      isNil(volumeFromStorage) || isNaN(volumeFromStorage)
        ? volume
        : volumeFromStorage;

    actions.setVolume(volumeToSet);
  });
}
